import { component } from 'picoapp'
import Toggle from '@/lib/Toggle'

export default component((node, ctx) => {
    const   toggles = node.querySelectorAll('[data-toggle]'),
            contents = node.querySelectorAll('[data-content]')

    const toggle = new Toggle(toggles, contents, true)
})